import { Dialog, DialogTitle, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";

import { APIError } from "src/types";
import { parseServerError } from "src/utils/string.utils";

export interface Props {
  open: boolean;
  data: APIError[];
  onClose: (event: MouseEvent) => void;
}

export function ErrorsDialog(props: Props) {
  const { onClose, open, data } = props;
  const { t } = useTranslation();

  function handleClose(event: MouseEvent) {
    onClose(event);
  }

  return (
    <StyledDialog onClose={handleClose} aria-labelledby="errors-dialog-title" open={open}>
      <DialogTitle className="title">
        <Typography variant="h2">{t("label.errorDetails")}</Typography>
      </DialogTitle>
      <List>
        {[...data].map((errorItem, i) => (
          <ListItem key={errorItem.key + i} divider={i + 1 < data.length}>
            <ListItemText primary={parseServerError(errorItem)} />
          </ListItem>
        ))}
      </List>
    </StyledDialog>
  );
}

const StyledDialog = styled(Dialog)`
  .title {
    .MuiTypography-root {
      color: ${({ theme }) => theme.palette.error.main};
    }
  }
`;
